import { Box, Typography } from '@mui/material'
import DataTable from 'components/DataTable/DataTable'
import { IHeader } from 'components/DataTable/IHeader'
import useUOMConversion from 'hooks/useUOM/useUOMConversion'
import { isEmpty } from 'lodash-es'
import { UOMContract } from 'models'
import { UOMClassContract } from 'models/UOMClassContract'
import { useUOMsContext } from 'pages/UOMsPage/context/UOMsContext'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import nameof from 'utilities/nameof'

const fields = nameof<UOMClassContract>()

function UOMClassesLookupTable() {
    const { uomClasses, loading, systemUOMs, customUOMs } = useUOMsContext()
    const { getConvertibleUOMs } = useUOMConversion(
        systemUOMs.concat(customUOMs),
    )
    const { t } = useTranslation()
    const headers: IHeader[] = useMemo(
        () => [
            {
                label: t('uoms.label.uom_category_name'),
                value: fields.name,
            },
            {
                label: t('uoms.label.units'),
                value: (row: UOMClassContract) => {
                    var uoms = row.uoms ?? []

                    if (isEmpty(uoms))
                        return (
                            <Typography color="disabled.contrastText">
                                {t('uoms.label.none')}
                            </Typography>
                        )

                    var baseUnits = uoms.filter((i) => i.isBaseUOM)
                    var indepedentUnits = uoms
                        .filter((i) => !i.enableConversion)
                        .flatMap((u) => u.symbol!)

                    return (
                        <>
                            {baseUnits.map((baseUnit: UOMContract) => {
                                var baseUnitSymbol = baseUnit.symbol
                                var sameTreeUOMs = getConvertibleUOMs(
                                    baseUnit.uomid!,
                                )
                                var notBasedUnits = sameTreeUOMs
                                    .filter((u) => !u.isBaseUOM)
                                    .flatMap((u) => u.symbol!)
                                return (
                                    <Box display="flex" key={baseUnit.uomid}>
                                        {baseUnitSymbol && (
                                            <Typography fontWeight={'bold'}>
                                                {baseUnitSymbol}{' '}
                                                <Typography
                                                    variant="caption"
                                                    fontWeight={'bold'}
                                                >
                                                    {' '}
                                                    ({t('uoms.label.base_unit')}
                                                    )
                                                </Typography>
                                            </Typography>
                                        )}
                                        {!isEmpty(notBasedUnits) && (
                                            <Typography>
                                                , {notBasedUnits.join(', ')}
                                            </Typography>
                                        )}
                                    </Box>
                                )
                            })}
                            {!isEmpty(indepedentUnits) && (
                                <Box display="flex" alignItems={'center'}>
                                    <Typography
                                        variant="caption"
                                        fontWeight={'bold'}
                                        pr={1}
                                    >
                                        {t('uoms.label.independent_units')}
                                    </Typography>

                                    <Typography>
                                        {indepedentUnits.join(', ')}
                                    </Typography>
                                </Box>
                            )}
                        </>
                    )
                },
            },
        ],
        [t, getConvertibleUOMs],
    )

    return (
        <DataTable
            data={uomClasses}
            headers={headers}
            itemKey={fields.uomClassID}
            loading={loading}
            selectMode={false}
        />
    )
}

export default UOMClassesLookupTable
